// Module
var code = "<div class=modal-content> <div class=modal-header> <span class=close-note>&#128128;</span> <h2 ref=title>&#128221; Add Fretboard info</h2> </div> <div class=modal-body> <form> <textarea name=note cols=30 rows=20 ref=note></textarea> </form> <br> <h4 class=save-note>Save &#128076;</h4> </div> </div>";
// Exports
module.exports = code;